import { Helmet } from "react-helmet"
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  Dialog,
  DialogContent,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  Icon,
  Avatar,
  MenuItem,
  Menu,
  Select,
  Popover,
  DialogActions,
  TextField,
  FormControl,
  IconButton,
} from "@mui/material"
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import React, { useEffect, useRef, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link as RouterLink, useNavigate, useLocation, useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import { makeStyles } from "@mui/styles"
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import moment from 'moment'

import * as Util from "../../../../services/global.service"
import { getGoalListV2, getGoalAlignmentDetail, getGoalAlignmentChild, deleteMember, getMyGoalProgress, putUpdateProgress, deleteGoal } from "../../../../actions/corporateGoal"
import { getMyGoalDetail } from "../../../../actions/mygoal"

import MessageDialog from "../../../../components/inbox/MessageDialog"
import HistoryDialog from "../../../../components/corporateGoal/HistoryDialog"
import { ReactComponent as ArrowRight } from "../../../../icons/arrow-circle-right.svg"
import { ReactComponent as Trash } from "../../../../icons/trash-alt-red.svg"
import { ReactComponent as NoDataIcon } from "../../../../assets/icons/nodata.svg"
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg"
import { ReactComponent as History } from "../../../../icons/history-2.svg"
import { ReactComponent as NoDataIcon2 } from "../../../../icons/no-data.svg"
import { ReactComponent as CascadeGoal } from "../../../../icons/cascade-goal.svg"
import { ReactComponent as FilterIcon } from "../../../../icons/filter.svg"
import { ReactComponent as EditIcon } from "../../../../icons/edit.svg"
import { ReactComponent as DeleteIcon } from "../../../../icons/delete.svg"
import { ReactComponent as CancelDelete } from "../../../../icons/cancel-delete.svg"
import { ReactComponent as ScaleIcon } from "../../../../icons/scale.svg"
import { ReactComponent as AuditLog } from "../../../../assets/icons/auditLog.svg"
import { ReactComponent as OrganizationChartIcon } from "../../../../assets/icons/org-chart.svg"

import SimpleDialog from "../../../../components/SimpleDialog"
import ConfirmDialog from "../../../../components/ConfirmDialog"
import WarningDialog from "../../../../components/WarningConfirm"
import DialogAuditLog from "./DialogAuditLog"
import ClearIcon from "@mui/icons-material/Clear"
import dayjs from 'dayjs'
import { useDebouncedCallback } from 'use-debounce';

const GoalAlignment = (props) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const _ = require("lodash")
  let { serial } = useParams()
  const { state } = useLocation()

  const goalDetailRef = useRef(null)

  // dialog
  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false)
  const handleCloseDialog = () => {
    openUpdateDialog(false)
  }

  const handleOpenUpdateDialog = () => {
    openUpdateDialog(true)
    //loadData()
  }

  const updateGoal = () => {
    openUpdateDialog(false)
    const sendData = {
      goal_id: goalDetail?.goal?.serial,
      target_value: targetValue,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }
    dispatch(putUpdateProgress(goalDetail?.goal?.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          openSuccessUpdateDialog(true)
          resetUpdateProgress()
          loadData()
        }
      })
  }

  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false)
  const [isSuccessDeleteCorporateGoalDialogOpen, openSuccessDeleteCorporateGoalDialog] = React.useState(false)
  const [isSuccessUpdateDialogOpen, openSuccessUpdateDialog] = React.useState(false)

  const [isAlertDialogOpen, openAlertDialogOpen] = React.useState(false)
  const [title, setTitle] = React.useState("")
  const [message, setMessage] = React.useState("")
  const [color, setColor] = React.useState("")
  const [colorHover, setColorHover] = React.useState("")
  const [size, setSize] = React.useState("")
  const [typeAlertDialog, setTypeAlertDialog] = React.useState("")
  const [errorText, seterrorText] = React.useState("")
  const [goalDetail, setGoalDetail] = React.useState({})
  const [fullVersion, setFullVersion] = React.useState(false)
  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})
  const [childGoalData, setChildGoalData] = React.useState({})
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false)
  const [deleteSerial, setDeleteSerial] = React.useState(null)
  const [workloadFormSelectValue, setWorkloadFormValue] = React.useState("")
  const [openDialogAuditLog, setOpenDialogAuditLog] = React.useState(false)
  const [members, setMembers] = React.useState([])
  const [filterMember, setFilterMember] = React.useState('')
  const [memberFilterd, setMemberFilterd] = React.useState([])

  const onCloseAlertDialog = () => {
    setTitle("")
    setMessage("")
    setColor("")
    setTypeAlertDialog("")
    setColorHover("")
    setSize("")
    openAlertDialogOpen(false)
  }
  const [loadingData, setLoadingData] = React.useState(true)
  const [loadingChild, setLoadingChild] = React.useState(true)

  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false)
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false)
  }

  const [openHistoryDialog, setHistoryDialog] = React.useState(false)
  const [historyData, setHistoryData] = React.useState([])
  const [historyOptionalData, setHistoryOptionalData] = React.useState([])
  const handleHistoryDialog = (val) => {
    setHistoryDialog(val)
  }

  const [targetValue, setTargetValue] = React.useState(null)
  const [progressValue, setProgressValue] = React.useState(null)
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()))
  const [remark, setRemark] = React.useState("")

  const callBackHistory = () => {
    /*
    dispatch(getGoalAlignmentDetail(serial))
      .then(resp => {
        let data = resp.data
        let memberList = data?.goal_member?.members || []

        setGoalDetail(data)
        setLoadingData(false)
        setChildGoalData(data.child_goal)
        setGoalScaleData(data.goal_scale)
        if ((data?.goal_progress?.goal_metric?.description === 'Date' || data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && data?.goal_progress?.actual_value !== '') {
          let splitDate = data?.goal_progress?.actual_value?.split("/")
          splitDate = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`
          setTargetValue(Util.formatDate(splitDate) || null)
        } else {
          var date = null
          if (data?.goal_progress?.actual_value === '' && (data?.goal_progress?.goal_metric?.description === 'Date' || data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
            date = dayjs().format('MM/DD/YYYY')
          } else {
            date = resp?.data?.goal_progress?.actual_value || null
          }
          setTargetValue(date)
        }
        setProgressValue(data?.goal_progress?.goal_progress_data?.serial)
        if (data) {
          let tmp = {
            goal_name: data?.goal?.name,
            target_value: data?.goal_progress?.target_value,
            target_condition: data?.goal?.target_condition,
            type: data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
          }
          setHistoryOptionalData(tmp)
        }
      })
    */

    /*
    dispatch(getMyGoalDetail(serial))
      .then(resp => {
        if (resp.data?.log_goal_progress) {
          setHistoryData(resp.data?.log_goal_progress)
        }
      })
    */
  }

  useEffect(() => {
    if (openHistoryDialog) {
      callBackHistory()
    }
  }, [openHistoryDialog])

  const handleClearClick = () => {
    setTargetValue(null)
  }

  const resetUpdateProgress = () => {
    setAsOfDate(Util.formatDate(new Date()))
    setRemark("")
    setTargetValue(null)
  }

  const goto = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data })
    } else {
      navigate("/admin" + route, { replace: false })
    }
  }

  const upperFirstWord = (str) => {
    if (str) {
      var splitStr = str.toString().toLowerCase().split(' ')
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
      }
      // Directly return the joined string
      return splitStr.join(' ')
    }
  }

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }))

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete') {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }

  // ----------------------------------
  const useStyles = makeStyles({
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    removeMember: {
      cursor: "pointer",
      "& > stroke": {
        fill: "#CC6058"
      },
      '& g > stroke': {
        fill: '#CC6058'
      },
    },
    primaryColorSvg: {
      "& > stroke": {
        fill: "#5DA196"
      },
      '& g > stroke': {
        fill: '#5DA196'
      },
      "& > path": {
        fill: "#5DA196"
      },
      '& g > path': {
        fill: '#5DA196'
      },
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
      memberHover: {
        cursor: "pointer",
        background: "red",
        '&:hover': {
          color: 'rgba(93, 161, 150, 0.1) !important'
        }
      },
    },
  })
  const classes = useStyles()
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  }

  const handleViewGoalChart = () => {
    window.open(`/admin/manage-corporate-goal/${serial}/chart`, '_blank')
  }

  const [goalProgressOption, setGoalProgressOption] = React.useState([])
  const [goalScaleData, setGoalScaleData] = React.useState([])
  const [targetCondition, setTargetCondition] = React.useState("")

  const loadData = () => {
    var mockupProgress = {
      code: "not_started",
      color: "{\"font\": \"#DADADA\", \"background\": \"#FFFFFF\"}",
      is_default: true,
      name: "Not Started",
      seq: 1,
      serial: "bfaeaf1f-f5ad-4ddb-b02d-624f05d16da0"
    }
    mockupProgress.color = JSON.parse(mockupProgress.color)
    setGoalProgressMockup(mockupProgress)
    dispatch(getGoalAlignmentDetail(serial)).then(resp => {
      let data = resp.data
      console.log('Resp', data)
      setGoalDetail(data)
      setLoadingData(false)
      //setChildGoalData(data.child_goal)
      setGoalScaleData(data.goal_scale)
      if ((data?.goal_progress?.goal_metric?.description === 'Date' || data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && data?.goal_progress?.actual_value !== '') {
        let splitDate = data?.goal_progress?.actual_value?.split("/")
        splitDate = `${splitDate[1]}/${splitDate[0]}/${splitDate[2]}`
        setTargetValue(Util.formatDate(splitDate) || null)
      } else {
        var date = null
        if (data?.goal_progress?.actual_value === '' && (data?.goal_progress?.goal_metric?.description === 'Date' || data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
          date = dayjs().format('MM/DD/YYYY')
        } else {
          date = resp?.data?.goal_progress?.actual_value || null
        }
        setTargetValue(date)
      }
      setTargetCondition(data?.goal_progress?.target_condition ?? "")
      setProgressValue(data?.goal_progress?.goal_progress_data?.serial)
      if (data) {
        let tmp = {
          goal_name: data?.goal?.name,
          target_value: data?.goal_progress?.target_value,
          target_condition: data?.goal?.target_condition,
          type: data?.goal_progress?.goal_metric?.description?.toLowerCase() ?? ""
        }
        setHistoryOptionalData(tmp)

        let memberList = _.filter(data.goal_member?.members || [], (o) => { return o.code !== '' })

        setHistoryData(data?.log_goal_progress || [])

        if (memberList.length > 0) {
          setMembers(memberList)
          setMemberFilterd(memberList)
        }
        else {

          dispatch(getMyGoalDetail(serial)).then(resp => {
            /*
            if (resp.data?.log_goal_progress) {
              setHistoryData(resp.data?.log_goal_progress)
            }
            */

            setMembers(_.filter(resp.data?.goal_member?.members || [], (o) => { return o.code !== '' }))
            setMemberFilterd(_.filter(resp.data?.goal_member?.members || [], (o) => { return o.code !== '' }))
          })

        }


        dispatch(getMyGoalProgress(serial))
          .then(resp => {
            if (resp.success)
              setGoalProgressOption(resp.data.goal_progress_data)
            setLoadingData(false)
          })



      }
    })

    setLoadingChild(true)
    dispatch(getGoalAlignmentChild(serial)).then(resp => {
      if (resp.success) setChildGoalData(resp.data.child_goal)

      setLoadingChild(false)
    })

  }

  const convertDateFormat = (list) => {
    if (list.metric.description == 'Date') {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    } else {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {`${list.target_value ? `${list.target_value} ${list.unit?.description || ''}` : '-'}`}
        </Typography>
      )
    }
  }

  const [removeMemberSerial, setRemoveMemberSerial] = React.useState(null)
  const [removeMemberSerialSelected, setRemoveMemberSerialSelected] = React.useState(null)
  const [removeMemberNameSelected, setRemoveMemberNameSelected] = React.useState(null)
  const [openConfirmRemoveMemberDialog, setOpenConfirmRemoveMemberDialog] = React.useState(false)

  const handleConfirmRemoveMemberDialog = (member) => {
    setOpenConfirmRemoveMemberDialog(true)

    let label = member?.fullname
    label += ` [${member?.code}]`
    if (member?.options?.goal_template) label += ` (${member?.options?.goal_template})`

    setRemoveMemberNameSelected(label)
    setRemoveMemberSerialSelected(member?.options?.form_evaluate)
  }

  const handleRemoveMember = () => {
    let form = {
      goal_id: goalDetail?.goal_serial,
      member: removeMemberSerialSelected
    }
    dispatch(deleteMember(form))
      .then(resp => {
        if (resp?.success) {
          setOpenConfirmRemoveMemberDialog(false)
          openSuccessDeleteDialog(true)
        } else {
          loadData()
        }
      })
  }

  const handleSuccessRemoveMemberDialog = () => {
    openSuccessDeleteDialog(false)
    loadData()
  }

  const getGoalScale = (serial = "", actualValue = "", type = "") => {
    let foundScale = goalScaleData.filter(item => item.goal_serial === serial)
    let actual = actualValue ?? ""
    let result = { valid: false, level: 0 }
    if (foundScale && foundScale?.length > 0) {
      foundScale.forEach(scale => {
        if (type?.toLowerCase() === "value") {
          if (parseFloat(actual) >= parseFloat(scale.min) && parseFloat(actual) <= parseFloat(scale.max)) {
            result.level = scale.level
            result.valid = true
            return result
          }
        } else if (type?.toLowerCase() === "date") {
          let actualDate = moment(actual, "DD/MM/YYYY").format('DD/MM/YYYY')
          if (actualDate === "Invalid date" && actual !== "") {
            actualDate = moment(actual, "MM/DD/YYYY").format('DD/MM/YYYY')
            if (actualDate === "Invalid date" && actual !== "") {
              actualDate = moment(actual, "YYYY-MM-DD").format('DD/MM/YYYY')
            }
          }
          let min = moment(scale.min, "DD/MM/YYYY").format('DD/MM/YYYY')
          let max = moment(scale.max, "DD/MM/YYYY").format('DD/MM/YYYY')
          if (actualDate >= min && actualDate <= max) {
            result.level = scale.level
            result.valid = true
            return result
          }
        }
      })
    }
    return result
  }

  const [checkboxFilter, setCheckboxFilter] = React.useState([true, true, true, true, true, false])
  const [checkboxStatus, setCheckboxStatus] = React.useState("all")
  const [filterCheckbox, setFilterCheckbox] = React.useState({
    selectAll: false,
    new: true,
    update: true,
    pending: true,
    approved: true,
    pendingDelete: true,
    inActive: false,
  })
  const [filterClick, setFilterClick] = React.useState(null)
  const open = Boolean(filterClick)
  const id = open ? 'simple-popover' : undefined
  const handleClickFilters = (event) => {
    setFilterClick(event.currentTarget)
  }
  const handleCloseFilter = () => {
    setFilterClick(null)
  }

  const handleCheckbox = (data) => {
    let tmp = [...checkboxFilter]
    if (data === "all") {
      if (checkboxStatus === "indeterminate" || checkboxStatus === "none") {
        tmp = tmp.map(item => item = true)
      } else if (checkboxStatus === "all") {
        tmp = tmp.map(item => item = false)
      }
    } else if (data === "new") {
      tmp[0] = !tmp[0]
    } else if (data === "update") {
      tmp[1] = !tmp[1]
    } else if (data === "pending") {
      tmp[2] = !tmp[2]
    } else if (data === "approved") {
      tmp[3] = !tmp[3]
    } else if (data === "pending_delete") {
      tmp[4] = !tmp[4]
    } else if (data === "inactive") {
      tmp[5] = !tmp[4]
    }
    setCheckboxFilter(tmp)
  }

  const checkCheckboxStatus = () => {
    let countChecked = 0
    let result = "none"
    let filterCheck = { ...filterCheckbox }
    checkboxFilter.forEach(item => {
      if (item) countChecked++
    })
    if (countChecked === checkboxFilter.length) {
      result = "all"
      filterCheck.selectAll = true
    } else if (countChecked > 0 && countChecked < checkboxFilter.length) {
      result = "indeterminate"
      filterCheck.selectAll = false
    } else if (countChecked === 0) {
      result = "none"
      filterCheck.selectAll = false
    }
    setCheckboxStatus(result)
    filterCheck.new = checkboxFilter[0]
    filterCheck.update = checkboxFilter[1]
    filterCheck.pending = checkboxFilter[2]
    filterCheck.approved = checkboxFilter[3]
    filterCheck.pendingDelete = checkboxFilter[4]
    filterCheck.inActive = checkboxFilter[5]
    setFilterCheckbox(filterCheck)
  }

  const validateActualValueColor = (data) => {
    let result = false
    let targetCondition = ""
    if (historyOptionalData?.target_condition && historyOptionalData?.target_condition !== "") {
      targetCondition = historyOptionalData.target_condition.toLowerCase()
    }
    if (targetCondition !== "") {
      if (targetCondition === "equal") {
        if (parseFloat(historyOptionalData?.target_value) === parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher or equal to") {
        if (parseFloat(historyOptionalData?.target_value) <= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less or equal to") {
        if (parseFloat(historyOptionalData?.target_value) >= parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "higher") {
        if (parseFloat(historyOptionalData?.target_value) < parseFloat(data)) {
          result = true
        }
      } else if (targetCondition === "less") {
        if (parseFloat(historyOptionalData?.target_value) > parseFloat(data)) {
          result = true
        }
      }
    } else {
      if (historyOptionalData?.type === "accomplishment") {
        if (historyOptionalData?.target_value?.toLowerCase() === data?.toLowerCase()) {
          result = true
        }
      } else if (historyOptionalData?.type === "date") {
        if (historyOptionalData?.target_value >= data) {
          result = true
        }
      } else {
        if (historyOptionalData?.target_value >= data) {
          result = true
        }
      }
    }
    return result
  }

  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const [actualValueData, setActualValueData] = React.useState("")

  const options = [
    t('mygoal.label.edit'),
    t('mygoal.label.auditLog'),
    t('mygoal.label.delete')
  ]

  const [anchorEl, setAnchorEl] = React.useState(null)
  const openOption = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleOption = (option, data = {}) => {
    setAnchorEl(null)
    if (option == t('mygoal.label.delete')) {
      openConfirmDeleteDialog(true)
      setDeleteSerial(serial)
    } else if (option === t('mygoal.label.auditLog')) {
      setOpenDialogAuditLog(true)
    } else if (option === t('mygoal.label.edit')) {
      let detail = null
      if (Util.formatData(state?.data, false) === false) {

        goto('/manage-corporate-goal/create/edit', { goalSerial: goalDetail?.goal?.serial, cycleSerial: goalDetail?.cycle_id })

        return
        dispatch(getGoalListV2(goalDetail.cycle_id)).then(resp => {
          if (resp?.data) {
            let goalList = resp.data?.my_goal_list?.goal_list ?? []
            for (let i = 0; i < goalList.length; i++) {
              if (goalList[i]?.goal_items?.length > 0) {
                detail = goalList[i].goal_items.find(goalItem => goalItem?.serial === serial)
                if (detail) {
                  break
                }
              }
            }
          }
          if (detail) {
            Object.assign(detail, { goalSerial: detail.serial, cycleSerial: goalDetail?.cycle_id })
            goto('/manage-corporate-goal/create/edit', detail)
          } else {
            alert("Error, Cannot get data.")
          }
        })
      } else {
        Object.assign(state?.data, { goalSerial: serial, cycleSerial: state?.cycleSerial })
        goto('/manage-corporate-goal/create/edit', state?.data)
      }
    }
  }

  const handleConfirmDeleteList = () => {
    openConfirmDeleteDialog(false)
    dispatch(deleteGoal(deleteSerial))
      .then(resp => {
        if (resp?.data?.success) {
          openSuccessDeleteCorporateGoalDialog(true)
        }
      })
  }

  const handleConfirmDelete = () => {
    openSuccessDeleteCorporateGoalDialog(false)
    goto('/manage-corporate-goal')
  }

  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  }
  // useEffect
  useEffect(() => {
    console.log(serial)
    loadData()
  }, [serial])

  useEffect(() => {
    let tmpData = JSON.parse(JSON.stringify(historyData))
    tmpData.sort(function (a, b) {
      return b.date.localeCompare(a.date) || b.created_at - a.created_at
    })
    setActualValueData(tmpData?.[0] ?? "")
  }, [historyData])

  useEffect(() => {
    checkCheckboxStatus()
  }, [checkboxFilter])

  useEffect(() => {
    if (goalDetail?.goal_progress && goalDetailRef) {
      let height = goalDetailRef?.current?.clientHeight ?? 0
      if (height && height > 0) {
        document.getElementById('goal-members-card').setAttribute("style", `height: ${height}px`)
      }
    }
  }, [goalDetail, goalDetailRef])


  useEffect(() => {
    console.log('goalDetail', goalDetail)
  }, [goalDetail])


  const handleFilterMember = useMemo(
    () =>
      _.debounce((value) => {
        console.log('Filter member', value)
        if (value) {
          const result = members.filter(member =>
            member.fullname.toLowerCase().includes(value.toLowerCase()) || member.code.toLowerCase().includes(value.toLowerCase())
          );
          setMemberFilterd(result);
        } else {
          setMemberFilterd(members);
        }
      }, 0.2 * 1000),
    [members]
  );

  return (
    <>
      <Helmet>
        <title>Goal Alignment | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => navigate('/kpi/home', { replace: false })}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('/manage-corporate-goal')}>
                {` ${t('corporateGoal.label.title')}`}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.goalAlignment')}`}
              </span>
            </Typography>
          </Grid>
          {!loadingData &&
            <Grid container mt={2} mb={3}>
              <Grid item xs={7} >
                <Grid container direction="row">
                  <Grid item mr={1}>
                    <Typography color="#404349" fontSize={36} lineHeight="39.6px" fontWeight="600">
                      {`${goalDetail?.goal?.name ?? "-"}`}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs="auto" ml="auto" display="flex" flexDirection="row">
                <Grid container>
                  {
                    (process.env.REACT_APP_MODE !== "uat" && process.env.REACT_APP_MODE !== "staging" && process.env.REACT_APP_MODE !== "production") &&
                    <Grid item pr={2}>
                      <Button
                        size="small"
                        aria-controls="view-goal-chart"
                        aria-haspopup="false"
                        onClick={() => handleViewGoalChart()}
                        color="primary"
                        variant="outlined"
                        sx={{ textTransform: 'none', pl: '8px', pr: '8px', borderColor: "#5DA196", height: "41px" }}
                      >
                        <OrganizationChartIcon sx={{ width: "20px", height: "17.5px" }} className={classes.primaryColorSvg} />
                        <Typography ml={1} fontSize={16} fontWeight={600}>
                          {t('label.viewGoalChart')}
                        </Typography>
                      </Button>
                    </Grid>
                  }
                  <Grid item>
                    <Button
                      size="small"
                      aria-controls="update-progress"
                      aria-haspopup="true"
                      onClick={() => handleOpenUpdateDialog(true)}
                      color="primary"
                      variant="contained"
                      sx={{ textTransform: 'none', pl: '8px', pr: '8px' }}
                    >
                      <Icon style={{ color: 'white', fontSize: 25 }}>{'rotate_left'}</Icon>
                      <Typography ml={1} style={{ color: fullVersion ? '#FFF' : '#F7F7F7' }}>
                        {t('corporateGoal.label.update')}
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>
                  <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openOption ? 'long-menu' : undefined}
                    aria-expanded={openOption ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                    sx={{
                      ml: "16px", borderRadius: '5px', border: '1px solid #E5E5E5', pl: '1px', pr: '1px', pt: '7.5px', pb: '7.5px',
                      "&:hover": {
                        backgroundColor: "#EFF6F4"
                      }
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    MenuListProps={{
                      'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl}
                    open={openOption}
                    onClose={handleOption}
                    PaperProps={{
                      style: {
                        maxHeight: 48 * 4.5,
                        width: '20ch',
                      },
                    }}
                  >
                    {options.map((option) => (
                      <MenuItem key={option} onClick={() => handleOption(option, goalDetail)} disabled={(((option === t('mygoal.label.delete') && state?.is_owner === false) || (option === t('mygoal.label.edit') && goalDetail?.goal?.aproval_status === 'pending_delete') || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && state?.workflowEnd) || ((option == t('mygoal.label.edit') || option == t('mygoal.label.delete')) && !state?.isCreatable) || (state?.isGoalOwner && option == t('mygoal.label.delete')) || (state?.isCreatable === false && option == t('mygoal.label.delete'))) && (goalDetail.is_owner || state?.isGoalOwner))} sx={{ color: (option === t('mygoal.label.delete') && goalDetail?.goal?.aproval_status === 'pending_delete') ? '#CC6058' : "#404349" }}>
                        {
                          option == t('mygoal.label.auditLog') ?
                            <AuditLog style={{ marginTop: '5px', marginRight: '5px' }} />
                            : option == t('mygoal.label.edit') ?
                              <EditIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                              : option === t('mygoal.label.delete') &&
                                goalDetail?.goal?.aproval_status === 'pending_delete' ?
                                <CancelDelete style={{ marginTop: '5px', marginRight: '5px' }} />
                                : <DeleteIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                        }
                        {(option === t('mygoal.label.delete') && goalDetail?.goal?.aproval_status === 'pending_delete') ? t('mygoal.label.cancelDeleteBtn') : option}
                      </MenuItem>
                    ))}
                  </Menu>
                </Grid>
              </Grid>
            </Grid>
          }
          {!loadingData
            ?
            <React.Fragment>
              <Grid container spacing={4}>
                <Grid lg={6} xs={12} item>
                  <Card style={{ height: '100%' }} sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                    <CardContent sx={{ paddingBottom: "0!important" }}>
                      <Grid item lg={12} xs={12} container>
                        <Grid
                          item
                          lg={12}
                          xs={12}
                          display="flex"

                        >
                          <Grid item display="flex" alignItems="center" justifyContent="center">
                            <Typography fontSize={24} fontWeight="600">
                              {t('corporateGoal.label.goalProgress')}
                            </Typography>
                          </Grid>
                          <Grid item ml="auto">
                            <Button onClick={() => handleHistoryDialog(true)} color="primary" variant="text">
                              <History />
                              <Typography ml={1} sx={{ textTransform: "none" }}>{t("corporateGoal.label.history")}</Typography>
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12} mb={3} ml={1} ref={goalDetailRef}>
                        <Grid item lg={5} xs={12} mb={2} mt={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.startEndDate').replace(':', '')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2} mt={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {goalDetail.goal_progress?.start_date} - {goalDetail.goal_progress?.end_date}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('mygoal.label.measurement')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {goalDetail?.goal?.measurement || '-'}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.goalMetric').replace(':', '')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {goalDetail.goal_progress?.goal_metric?.description}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.targetValue').replace(':', '')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {Util.upperFirstWord(targetCondition ?? '')}  {goalDetail.goal_progress?.goal_metric?.type == "Date" ? goalDetail.goal_progress?.target_value || '-' : goalDetail.goal_progress?.target_value || '-'}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.valueUnit')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {goalDetail.goal_progress?.unit || '-'}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2}>
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.labelActualValue')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2} display="flex" flexDirection="column">
                          <Typography fontWeight="400" fontSize={18} variant="label" color={goalDetail.goal_progress?.actual_value ? validateActualValueColor(actualValueData?.actual_value) ? "#5DA196" : "#CC6058" : "#828282"}>
                            {actualValueData ? actualValueData?.actual_value : '-'}
                          </Typography>
                          <Typography fontSize={14} fontWeight="400" variant="label">
                            {`( `} {t('corporateGoal.label.resultAsOf')}: {actualValueData ? actualValueData?.date ? Util.dateDayFormatAdmin(actualValueData.date) : "-" : "-"} {` )`}
                          </Typography>
                        </Grid>
                        <Grid item lg={5} xs={12} mb={2} display="flex" alignItems="center">
                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                            {t('corporateGoal.label.goalProgress')}
                          </Typography>
                        </Grid>
                        <Grid item lg={7} xs={12} mb={2}>
                          <Typography fontWeight="400" fontSize={18} variant="label">
                            {statusBox(
                              goalDetail?.goal_progress?.goal_progress_data
                                ? goalDetail?.goal_progress?.goal_progress_data
                                : goalProgressMockup
                            )}
                          </Typography>
                        </Grid>

                        {/* ### Waiting for API for loop Data */}
                        {goalDetail?.goal?.more_detail?.map((item) => {
                          return <>
                            <Grid item lg={5} xs={12} mb={2}>
                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                {item.label}
                              </Typography>
                            </Grid>
                            <Grid item lg={7} xs={12} mb={2}>
                              <Typography fontSize={18} color="#939393" fontWeight='400'>
                                {(item.type === 'dropdown' && item.value !== '')
                                  ? (i18n.language === "th-TH") ? item?.options?.data?.find((data) => data.id === item.value).label?.th : item?.options?.data?.find((data) => data.id === item.value).label?.en
                                  : Util.capitalizedString(item.value || '-') || '-'}
                              </Typography>
                            </Grid>
                          </>
                        })}
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid lg={6} xs={12} item>
                  <Card style={{ height: '100%' }} sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                    <CardContent>
                      <Grid item lg={12} xs={12} container>
                        <Grid
                          item
                          lg={12}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          textAlign="left"
                        >
                          <Grid md={7} item style={{ height: '30px' }} display="flex" justifyContent="start" alignItems="center">
                            <Typography lineHeight="21px" fontSize={24} fontWeight="600" sx={{ mr: 1 }}>
                              {t('corporateGoal.label.goalMember')}
                            </Typography>
                            <Typography lineHeight="21px" fontSize={24} fontWeight="500">({(memberFilterd.length !== members.length) ? memberFilterd.length + '/' + members.length : members.length})</Typography>
                          </Grid>
                          <Grid md={3} item textAlign="right">
                            <TextField
                              autoComplete='off'
                              style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic"
                              placeholder={t("label.filters")} variant="outlined" size="small" fullWidth
                              onChange={(e) => handleFilterMember(e.target.value)}
                            />
                          </Grid>
                          <Grid md={2} item textAlign="right">
                            <Box>
                              <Button onClick={() => navigate(`${location.pathname ?? ""}/add-members`, { replace: false, state: { cycleSerial: state?.cycleSerial } })} color="primary" variant="contained" sx={{ height: "34px" }}>
                                <PlusIcon className={classes.plusSvg} />
                                <Typography ml={1} sx={{ textTransform: "none" }} fontSize="16px" fontWeight="600">{t("label.add")}</Typography>
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12} sx={{ overflow: "auto", alignContent: "start", height: 400 }} columnSpacing={1} id="goal-members-card">
                        {
                          memberFilterd.length > 0 ?
                            memberFilterd.map((item, i) => {
                              return (
                                <Grid item lg={6} xs={12} mb={1} mt={1} key={item.serial + i}>
                                  <Grid container lg={12} xs={12} display="flex" justifyContent="start" alignItems="center" >
                                    <div className="hoverMember" style={{ display: "flex", justifyContent: "start", alignItems: "center", width: "100%", padding: "5px" }} >
                                      <Grid item display="flex" justifyContent="center">
                                        <Avatar
                                          src={item?.photo}
                                          sx={{
                                            width: 40,
                                            height: 40,
                                            marginRight: '10px'
                                          }}
                                        >
                                        </Avatar>
                                      </Grid>
                                      <Grid item display="flex" justifyContent="center" flexDirection="column">
                                        <Grid container lg={12} xs={12}>
                                          <Grid item display="flex">
                                            <Typography fontWeight="400" fontSize={16} color="#404349">{item.fullname}</Typography>
                                          </Grid>
                                        </Grid>
                                        <Grid container lg={12} xs={12}>
                                          <Grid item display="flex">
                                            <Typography fontWeight="400" fontSize={12} color="#A3A3A3">
                                              [{item.code}] {item.position}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        {item.options?.goal_template &&
                                          <Grid container lg={12} xs={12}>
                                            <Grid item display="flex">
                                              <Typography fontWeight="400" fontSize={12} color="#A3A3A3">{item.options?.goal_template}</Typography>
                                            </Grid>
                                          </Grid>
                                        }
                                      </Grid>
                                      <Grid item display="flex" justifyContent="center" alignItems="center" ml="auto">
                                        <Trash className={classes.removeMember} onClick={() => handleConfirmRemoveMemberDialog(item)} />
                                      </Grid>
                                    </div>
                                  </Grid>
                                </Grid>
                              )
                            })
                            :
                            <>
                              <Grid container xs="12" md="12" lg="12" xl="12" display="flex" justifyContent="center" alignItems="center" mt={2}>
                                <Grid item>
                                  <NoDataIcon />
                                </Grid>
                              </Grid>
                              <Grid container xs="12" md="12" lg="12" xl="12" display="flex" justifyContent="center" alignItems="center">
                                <Grid item>
                                  <Typography fontSize="20px" fontWeight="600" color="#A0A0A0">{t("corporateGoal.label.noMemberFound")}</Typography>
                                </Grid>
                              </Grid>
                              <Grid container xs="12" md="12" lg="12" xl="12" display="flex" justifyContent="center" alignItems="center">
                                <Grid item>
                                  <Typography fontSize="16px" fontWeight="400" color="#A0A0A0">{t("corporateGoal.label.pleaseAddGoalMember")}</Typography>
                                </Grid>
                              </Grid>
                            </>
                        }
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container direction="row" mt={3}>
                <Grid item lg={12} xs={12}>
                  <Card sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                    <CardContent>
                      <Grid container mb={1}>
                        <Grid item>
                          <Typography fontSize={24} fontWeight="600">
                            {t('corporateGoal.label.childGoal')} {childGoalData.length > 0 ? `(${childGoalData.length})` : ""}
                          </Typography>
                        </Grid>
                        <Grid item ml="auto">
                          <Button
                            size="small"
                            aria-controls="simple-menu"
                            aria-haspopup="true"
                            onClick={handleClickFilters}
                            color="black"
                            variant="outlined"
                            sx={{ marginRight: 2, height: "34px" }}
                            aria-describedby={id}
                            style={{ textTransform: 'none' }}
                          >
                            <FilterIcon style={{ width: '20px', height: '20px' }} />
                            <Typography ml={1} fontWeight="600" fontSize="16px">{t("corporateGoal.label.filters")}</Typography>
                          </Button>
                          <Popover
                            id={id}
                            open={open}
                            anchorEl={filterClick}
                            onClose={handleCloseFilter}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                          >
                            {checkboxFilter?.length > 0 ?
                              (<Box
                                sx={{
                                  p: 1,
                                }}>
                                <Box
                                  style={{ "padding-left": "14px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    style={{ fontSize: '14px' }}
                                    label={t("label.selectAll")}
                                    control={
                                      <Checkbox
                                        checked={checkboxStatus === 'all'}
                                        indeterminate={checkboxStatus === 'indeterminate'}
                                        onChange={() => handleCheckbox("all")}
                                        xs={{ pl: 0 }}
                                      />
                                    }
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.new')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[0]} onChange={() => handleCheckbox("new")} />}
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.update')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[1]} onChange={() => handleCheckbox("update")} />}
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.pending')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[2]} onChange={() => handleCheckbox("pending")} />}
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.approve')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[3]} onChange={() => handleCheckbox("approved")} />}
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.pendingDelete')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[4]} onChange={() => handleCheckbox("pending_delete")} />}
                                  />
                                </Box>
                                <Box
                                  style={{ "padding-left": "12px", "padding-right": "4px" }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center"
                                  }}>
                                  <FormControlLabel
                                    sx={{ ml: "0!important" }}
                                    style={{ fontSize: '14px' }}
                                    label={t('label.filter.inactive')}
                                    control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkboxFilter[5]} onChange={() => handleCheckbox("inactive")} />}
                                  />
                                </Box>
                              </Box>) : null
                            }
                          </Popover>
                          <Button onClick={() => navigate(`${location.pathname ?? ""}/cascade-goal`, { replace: false, state: { cycleSerial: state?.cycleSerial } })} color="primary" variant="contained" sx={{ height: "34px", minWidth: "150px" }}>
                            <CascadeGoal className={classes.plusSvg} />
                            <Typography ml={1} sx={{ textTransform: "none" }} fontSize="16px" fontWeight="600">{t("corporateGoal.label.cascadeGoal")}</Typography>
                          </Button>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: "10px", mb: 3 }} />
                      <Grid container columnSpacing={3} justifyContent={childGoalData.length > 0 ? "start" : "center"}>
                        {
                          childGoalData.length > 0
                            ?
                            childGoalData.filter((item) => {
                              if (filterCheckbox.selectAll) {
                                return item
                              } else {
                                if (filterCheckbox[item.goal_status?.description]) {
                                  return item
                                }
                              }
                            }).map((list, key) => {
                              return (
                                <Grid item mb={1} xs={12} sm={6} md={6} lg={6} xl={6} key={key} my={1}>
                                  <Card onClick={() => { /* openInNewTab(`/kpi/mygoal-detail/${list.serial}`) */ }} sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                                    <CardContent>
                                      <Grid lg={12} xs={12} container>
                                        <Grid
                                          item
                                          lg={12}
                                          xs={12}
                                          display="flex"
                                          alignItems="center"
                                          textAlign="left"
                                        >
                                          <Grid item direction="column">
                                            <Typography fontSize={20} lineHeight="21px" fontWeight="600">
                                              {list.name}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                      <Grid container lg={12} xs={12} mt={3}>
                                        <Grid lg={5} xs={12} mb={2} display="flex" alignItems="center">
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.approvalStatus")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2} display="flex" alignItems="center">
                                          {statusBox(list.goal_status.description ?? "")}
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2} display="flex" alignItems="center">
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.goalProgress")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2} display="flex" alignItems="center">
                                          {statusBox(Object.keys(list.progress_status).length > 0 ? list.progress_status : goalProgressMockup)}
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.goalWeight")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                            {list.weight} %
                                          </Typography>
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.startEndDate")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                            {`${list.start_date} - ${list.end_date}`}
                                          </Typography>
                                        </Grid>
                                        {/* <Grid lg={5} xs={12} mb={2}>
                                        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                          {t("corporateGoal.label.goalMetric")}
                                        </Typography>
                                      </Grid>
                                      <Grid lg={7} xs={12} mb={2}>
                                        <Typography fontSize={14} lineHeight="21px" fontWeight="400">
                                          {list.metric.description}
                                        </Typography>
                                      </Grid> */}
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.goalType")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                            {list.type.name || "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("mygoal.label.measurement")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                            {list.measurement || "-"}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.targetValue")}:
                                          </Typography>
                                        </Grid>
                                        <Grid lg={7} xs={12} mb={2}>
                                          {convertDateFormat(list)}
                                        </Grid>
                                        <Grid lg={5} xs={12} mb={2}>
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400" color="#A3A3A3">
                                            {t("corporateGoal.label.actualValue")}:
                                          </Typography>
                                        </Grid>
                                        <Grid xs={7} mb={2} display="flex" justifyContent="space-between">
                                          <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                            {`${list.actual_value ? `${list.actual_value} ${list.unit?.description || ''}` : '-'}`}
                                          </Typography>
                                          {
                                            (getGoalScale(list?.serial, list?.actual_value, list?.metric?.description)?.valid > 0 && list.actual_value) &&
                                            <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="right" sx={{ textTransform: "uppercase" }}>
                                              {t("corporateGoal.label.scaleLevel")} : {getGoalScale(list?.serial, list?.actual_value, list?.metric?.description)?.level}
                                            </Typography>
                                          }
                                        </Grid>
                                      </Grid>
                                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                      <Grid container direction="row" style={{ alignItems: 'center', paddingTop: "15px" }}>
                                        <Grid item>
                                          <BootstrapTooltip
                                            placement="left"
                                            arrow
                                            title={list.owner?.full_name}
                                            style={{ marginLeft: '5px', marginRight: 20 }}
                                          >
                                            <Avatar
                                              src={list.owner?.photo}
                                              sx={{
                                                width: 30,
                                                height: 30,
                                              }}
                                            >
                                            </Avatar>
                                          </BootstrapTooltip>
                                        </Grid>
                                        <Grid item>
                                          <Typography fontWeight="400" fontSize={16} color="#404349">
                                            {list.owner?.full_name}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              )
                            })
                            :
                            <React.Fragment>
                              <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                flexDirection="column"
                                p={1}
                              >
                                <Box>
                                  <NoDataIcon />
                                </Box>
                                <Box>
                                  <Typography fontSize="20px" fontWeight="600" color="#A0A0A0">{t("corporateGoal.label.noData")}</Typography>
                                </Box>
                              </Box>
                            </React.Fragment>
                        }
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </React.Fragment>
            :
            <Grid container spacing={2} mt={0}>
              <Grid item lg={12} md={12}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  p={1}
                  sx={{ minHeight: "400px" }}
                >
                  <Box>
                    <NoDataIcon />
                  </Box>
                  <Box>
                    <Typography fontSize="20px" fontWeight="600" color="#A0A0A0">{t('corporateGoal.label.noData')}</Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          }

          {/* success & confirm dialog */}
          <ConfirmDialog open={openConfirmRemoveMemberDialog} warning={true} doConfirm={handleRemoveMember} setValue={setOpenConfirmRemoveMemberDialog} title={t("corporateGoal.label.dialog.removeMemberTitle")} text={`${t("corporateGoal.label.dialog.removeMemberText")} ${removeMemberNameSelected ?? ""}?`} cancel={t("corporateGoal.label.dialog.cancelDelete")} confirm={t("corporateGoal.label.dialog.confirmDelete")} />
          <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={handleSuccessRemoveMemberDialog} text={t("corporateGoal.label.dialog.successRemoveMember")} title={t("label.success")} subTitle="" />
          <SimpleDialog open={isSuccessUpdateDialogOpen} setValue={openSuccessUpdateDialog} text={t("corporateGoal.label.dialog.successUpdateProgressDesc")} title={t("label.success")} subTitle="" />

          {/* history dialog */}
          <HistoryDialog open={openHistoryDialog} setValue={setHistoryDialog} data={historyData} serial={serial} isOwner={true} optionalData={historyOptionalData} doCallback={() => callBackHistory()} />

          {/* update progress dialog */}
          <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row">
                <Grid item lg={11}>
                  <Typography fontSize={24} fontWeight="600" color="#404349">
                    {t('mygoal.label.updateGoal')}
                  </Typography>
                </Grid>
                <Grid item lg={1} style={{ textAlign: 'right' }}>
                  <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                    X
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ paddingTop: "20px" }} />
              <Grid container>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalToUpdate')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="primary">
                    {goalDetail.goal?.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalMetric')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {goalDetail.goal_progress?.goal_metric.description}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.targetValue')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {Util.upperFirstWord(targetCondition ?? '')} {goalDetail.goal_progress?.target_value} {goalDetail.goal_progress?.unit && goalDetail.goal_progress?.unit !== "-" ? goalDetail.goal_progress?.unit : ""}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.resultAsOf')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      format="dd/MM/yyyy"
                      value={asOfDate}
                      onChange={(newValue) => {
                        if (newValue) {
                          setAsOfDate(Util.formatDate(newValue))
                        } else {
                          setAsOfDate(null)
                        }
                      }}
                      style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                      inputProps={{
                        placeholder: "As of date", sx: {
                          "&::placeholder": {
                            color: "#AAAAAA"
                          },
                          "&borderColor": {
                            color: '#CED4DA'
                          },
                          "color": '#404349'
                        }
                      }}
                      renderInput={(params) => <TextField {...params}
                        fullWidth
                        size="small"
                        style={{ color: '#404349' }}
                      />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.actualValue')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2} color="#404349">
                  {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                    ?
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container direction="row">
                        <Grid item lg={10}>
                          <DesktopDatePicker
                            format="dd/MM/yyyy"
                            value={targetValue}
                            onChange={(newValue) => {
                              if (newValue) {
                                setTargetValue(Util.formatDate(newValue))
                              } else {
                                setTargetValue(null)
                              }
                            }}
                            style={{ color: '#404349', fontWeight: '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                            inputProps={{
                              placeholder: "Current Value", sx: {
                                "&::placeholder": {
                                  color: "#AAAAAA"
                                },
                                "&borderColor": {
                                  color: '#CED4DA'
                                },
                                "color": '#404349'
                              }
                            }}
                            renderInput={(params) => <TextField {...params}
                              fullWidth
                              size="small"
                              style={{ color: '#404349' }}
                            />}
                          />
                        </Grid>
                        <Grid item>
                          <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                    :
                    (!goalDetail?.goal_progress?.goal_metric?.options)
                      ?
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          value={targetValue}
                          onChange={(val) => { setTargetValue(val.target.value) }}
                          renderValue={(selected) => {
                            if (selected === null) {
                              return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                            } else {
                              return <Typography color="#404349">{selected}</Typography>
                            }
                          }}
                          endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                        >
                          <MenuItem disabled value={""}>
                            <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                          </MenuItem>
                          <MenuItem value={"Success"}>Success</MenuItem>
                          <MenuItem value={"Fail"}>Fail</MenuItem>
                        </Select>
                      </FormControl>
                      :
                      <TextField
                        autoComplete='off'
                        style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                        InputProps={{
                          endAdornment: targetValue ? (
                            <IconButton onClick={handleClearClick}>
                              <ClearIcon />
                            </IconButton>
                          ) : undefined
                        }}
                      />

                  }
                  {
                    (getGoalScale(goalDetail?.goal?.serial, targetValue, goalDetail?.goal_progress?.goal_metric?.description)?.valid > 0 && targetValue && targetValue !== "") &&
                    <Grid xs={12}>
                      <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase" }}>
                        {t("corporateGoal.label.scaleLevel")} : {getGoalScale(goalDetail?.goal?.serial, targetValue, goalDetail?.goal_progress?.goal_metric?.description)?.level}
                      </Typography>
                    </Grid>
                  }
                </Grid>
                {/* <Grid item lg={2}></Grid> */}
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('mygoal.label.goalProgress')}:
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      value={progressValue}
                      onChange={(val) => { setProgressValue(val.target.value) }}
                      sx={{ color: "#404349" }}
                      renderValue={(selected) => {
                        if (selected === null) {
                          return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>
                        } else {
                          return goalProgressOption?.find((item) => item.serial === selected)?.name
                          // Mockup Because api is not working
                        }
                      }}
                    >
                      <MenuItem disabled value={null}>
                        <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                      </MenuItem>
                      {goalProgressOption?.map((item, key) => {
                        return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.remark')}:
                  </Typography>
                </Grid>
                <Grid item lg={12} pt={'7px'}>
                  <TextField
                    autoComplete='off'
                    multiline
                    rows={2}
                    maxRows={4}
                    style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Box classes="mt-3">
                <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
                  {t('mygoal.label.cancel')}
                </Button>
                <Button onClick={() => updateGoal()} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                  <Typography>
                    {t('mygoal.label.justUpdate')}
                  </Typography>
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
      <DialogAuditLog serial={serial} close={e => setOpenDialogAuditLog(false)} open={openDialogAuditLog} />
      <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={t("corporateGoal.label.dialog.deleteTitle")} text={t("corporateGoal.label.dialog.deleteText")} cancel={t("corporateGoal.label.dialog.cancelDelete")} confirm={t("corporateGoal.label.dialog.confirmDelete")} />
      <SimpleDialog open={isSuccessDeleteCorporateGoalDialogOpen} page={true} doDirect={handleConfirmDelete} setValue={openSuccessDeleteCorporateGoalDialog} text={t("corporateGoal.label.dialog.deleteSuccess")} title="Success" subTitle="" />
    </>
  )
}
export default GoalAlignment
